export default {
    'money.png': 'money.png',
    'need-cert-img.png': 'need-cert-img.png',
  }
  